import React from 'react';

import { CopyButton } from '@/components/frontend/articles/copy-button';
import { Divider } from '@/components/ui/divider';
import { highlight, SupportedLanguage } from '@/lib/frontend/highlighter';
import { cn } from '@/lib/shared/ui';

type Props = {
  code: string;
  language: SupportedLanguage;
  className?: string;
};

const bg = 'bg-[#24292e]';

export const CodeBlock = async (props: Props) => {
  const { code, language, className } = props;

  const html = await highlight(code, language);

  return (
    <div
      className={cn(
        'text-xs overflow-auto leading-relaxed [&_pre]:p-5 rounded-lg relative',
        className,
      )}
    >
      <div className={cn(bg)}>
        <div className="flex justify-between items-center p-1 px-3 pr-1 relative">
          <div className="font-mono text-white/50">{language}</div>
          <CopyButton text={code} />
        </div>
        <div className="opacity-50">
          <Divider containerClassName="bg-white/20" />
        </div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
};
